export default __webpack_public_path__ + "static/media/step-5-loop.3c96d938.mp4";